import $ from 'jquery';
import { TimeList } from './TimeList';
import { Preloader } from './Preloader';

export class ChoiceDateTimeForm {
    constructor(element) {
        this.element = element;
        this.form = $(element).closest('.js-datepicker-choice-date-time-wrapper');
        this.timeListElement = $(this.form).find('.js-datepicker-choice-date-time-elements');
        this.timeList = new TimeList(this.form[0].querySelector('#base-radio-time-template'));
        this.preloader = new Preloader(this.form);

        $(this.element).on('changeDate', (e) => {
            const dateString = e.detail.date.toLocaleDateString('ru-RU');
            this.form.find('.js-appointment-datepicker-input').val(dateString);
            this.fillTimeList(dateString);
        });
    }

    fillTimeList(date) {
        this.fetchTime(date)
            .then((response) => {
                this.preloader.hidePreloader();
                $(this.timeListElement).html('');
                if (response[0].ok) {
                    $(this.element).trigger('date:before-fill-time-list');
                    const newTimesList = [];
                    $(this.timeListElement).html('');

                    const timesList = response[0].data;

                    if (!timesList.length) {
                        $(this.timeListElement).html(response[1]);
                        return;
                    }

                    timesList.forEach((item) => newTimesList.push(this.timeList.fillElement(item)));

                    $(this.timeListElement).append(newTimesList);

                    $(this.element).trigger('date:fetch-success');
                    return;
                }
                $(this.element).trigger('date:fetch-error', {
                    error: response[1]
                });
            })
            .catch(() => {
                $(this.element).trigger('date:fetch-error', {
                    error: 'Произошла ошибка, повторите попытку позже'
                });
            });
    }

    getQueryParams() {
        const queryParams = new URLSearchParams(window.location.search.substring(1));
        return Object.fromEntries(queryParams);
    }

    fetchTime(date) {
        this.preloader.showPreloader();
        const queryParams = this.getQueryParams();
        return $.ajax({
            type: 'GET',
            data: { date: date, ...queryParams },
            dataType: 'json',
            url: '/zapisatsya_na_priem/apply_date/'
        });
    }
}

$('.js-datepicker-choice-date-time').each((i, element) => {
    new ChoiceDateTimeForm(element);
});
